import { Dialog, DialogContent, makeStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";

export const useStyles = makeStyles({
  contentWrap: {
    maxWidth: "560px",
  },
});

export const CustomDialog = withStyles({
  root: {
    "& .MuiPaper-root": {
      maxWidth: 520,
      padding: 0,
    },

    "& .MuiDialog-paperWidthSm": {
      maxWidth: 520,
      width: "100%",

      "@media screen and (max-width: 719px)": {
        position: "absolute",
        bottom: "-32px",
      },
    },
    "& .MuiPaper-rounded": {
      borderRadius: 4,
      overflow: "hidden",
    },

    "& .MuiDialog-paperScrollPaper": {
      maxHeight: "100%",
    },
  },
})(Dialog);

export const CustomDialogContent = withStyles({
  root: {
    position: "relative",
  },
})(DialogContent);
